<template>
	<div class="overview-card">
		<div class="overview-title">{{card.titleName}}</div>
		<div class="overview-content">
			<div class="overview-content-side">
				<div class="over-view-imgbox">
					<div class="img-common">
						<img src="@/assets/img/blue.jpg" alt="blue" />                   
						<span class="left-total">{{card.serving}}</span> 
					</div>             
					<div class="left-title">在保</div>
				</div>
			</div>
            <div class="overview-content-middle">
				<div class="over-view-imgbox">
					<img class="circle-animate" src="@/assets/img/circle.jpg" alt="circle" />        
					<span class="middle-total">{{card.serving+card.served}}</span>
				</div>
			</div>
			<div class="overview-content-side">
				<div class="over-view-imgbox">
					<div class="img-common">
						<img src="@/assets/img/yellow.jpg" alt="yellow" />
						<span class="right-total">{{card.served}}</span>  
					</div>                          
					<div class="right-title">过保</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'DgCard',
		props: ['card'],
		data(){
			return{
				userType:null
			}
		},
		methods: {    
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/card/DgCard.vue